import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'finops',
});

export const accountDetailRouteRef = createSubRouteRef({
  id: 'finops:account-detail',
  parent: rootRouteRef,
  path: '/:accountId',
});
